import Title from './Title';
import DetailTitle from './DetailTitle';

export { Title, DetailTitle };

export default { Title, DetailTitle };
